<template>
  <div class="input-time-picker">
    <label v-if="label" :class="labelClass">{{ label }}</label>
    <div class="input-group">
      <div class="position-relative w-80">
        <input
          :class="computedClassInput"
          :type="type"
          :id="id"
          :disabled="disabled"
          placeholder="00:00"
          :required="required"
          :min="min"
          :max="max"
          :value="convertTime24to12(value)"
          v-mask="inputMask"
          @blur="emitValue($event.target.value)"
          @keypress.enter="$emit('keypress', $event)"
        />
        <em
          v-if="icon && !error && !isValid"
          class="form-control-icon-normal"
          :class="computedEmClass"
        ></em>
      </div>
      <div class="input-group-append w-20">
        <button
          class="btn border dropdown-toggle border-left-0 bg-white rounded-right"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <span class="border-left pl-2">{{ meridian }}</span>
        </button>
        <div class="dropdown-menu">
          <a class="dropdown-item" @click="() => handlerMeridian('AM')">AM</a>
          <a class="dropdown-item" @click="() => handlerMeridian('PM')">PM</a>
        </div>
      </div>
    </div>
    <error
      v-if="!isValidTime"
      variant="no-border"
      message="La hora no es válida"
    />
    <error v-if="error" variant="no-border" :message="customErrorMsg" />
  </div>
</template>

<script>
import moment from 'moment';
import { mask } from 'ke-the-mask';
import Error from '@/components/common/Error';

const FORMAT_HOUR_24 = 'HH:mm';
const FORMAT_HOUR_AM_PM = 'h:mm A';

export default {
  name: 'CustomTimePicker',
  meta: {
    description: 'Componente para entrada de datos',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  components: {
    Error,
  },
  directives: {
    mask,
  },
  props: {
    id: {
      type: String,
      default: '',
      meta: {
        description: 'Id contenedor para los CustomInput',
        example: 'idCustomInput',
      },
    },
    type: {
      type: String,
      default: 'text',
      meta: {
        description: 'Propiedad type personalizada',
        example: 'Texto requerido',
      },
    },
    label: {
      type: String,
      default: '',
      meta: {
        description: 'Control para mostrar texto ',
        example: 'Texto requerido',
      },
    },
    labelClass: {
      type: String,
      default: 'text-dark font-weight-normal',
      meta: {
        description: 'Clases para el label',
        example: 'Texto requerido',
      },
    },
    placeholder: {
      type: String,
      default: '',
      meta: {
        description: 'Texto de referencia en el input',
        example: 'Texto requerido',
      },
    },
    value: {
      type: [String, Number],
      default: '',
      meta: {
        description: 'Parámetro de entrada en el input',
        example: 'Texto requerido',
      },
    },
    required: {
      type: String,
      default: function() {
        return '';
      },
      meta: {
        description: 'Estado requerido',
        example: 'required',
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      meta: {
        description: 'Estado deshabilitado',
        example: 'disabled',
      },
    },
    minlength: {
      type: String,
      default: '',
      meta: {
        description: 'Logitud mínima requerida',
        example: 'Texto requerido',
      },
    },
    maxlength: {
      type: String,
      default: '',
      meta: {
        description: 'Logitud máxima requerida',
        example: 'Texto requerido',
      },
    },
    min: {
      type: Number,
      default: 0,
      meta: {
        description: 'Límite mínimo  en el input ',
        example: '14',
      },
    },
    max: {
      type: Number,
      default: 100,
      meta: {
        description: 'Límite máximo en el input ',
        example: '14',
      },
    },
    step: {
      type: Number,
      default: 1,
      meta: {
        description: 'Rango de intervalos ',
        example: '14',
      },
    },
    error: {
      type: String,
      default: '',
      meta: {
        description: 'Estado error',
        example: 'Texto requerido',
      },
    },
    dirty: {
      type: Boolean,
      default: function() {
        return false;
      },
      meta: {
        description: 'Mostrar el checkmark si la validación es correcta',
        example: 'true',
      },
    },
    customErrorMsg: {
      type: String,
      default: function() {
        return this.error;
      },
      meta: {
        description: 'Personalización para mensajes de error',
        example: 'Texto requerido',
      },
    },
    canModifyCss: {
      type: Boolean,
      default: true,
      meta: {
        description: 'Control modificación ',
        example: 'true',
      },
    },
    leftIcon: {
      type: Boolean,
      default: () => true,
      meta: {
        description: 'Muestra el icono a la izquierda',
        example: 'true',
      },
    },
  },
  data() {
    return {
      icon: 'far fa-clock orange-icon',
      maskType: 'TimePicker',
      masked: true,
      maskTypes: [{ id: 'TimePicker', mask: '##:##' }],
      inputMask: '',
      formControlClass: 'form-control input-border shadow-none',
      isOpenMeridian: false,
      meridian: 'AM',
      isValidTime: true,
    };
  },
  computed: {
    isValid() {
      return !this.error && this.dirty;
    },
    computedClassInput() {
      let result = '';

      if (this.error) {
        result = ' was-Invalidated';
      } else if (this.isValid && this.canModifyCss) {
        result = ' was-validated';
      }

      if (this.leftIcon) {
        result = `${result} leftInput`;
      }
      return this.formControlClass + result;
    },
    computedEmClass() {
      let result = this.icon;

      if (this.leftIcon) {
        result = `${result} left`;
      }

      return result;
    },
    computedIconClass() {
      let result = 'form-control-icon-normal far fa-lock-alt';

      if (this.canModifyCss) {
        if (this.isValid) {
          result = 'fa fa-checkmark sucess-icon';
        }
      }

      return result;
    },
  },
  mounted() {
    if (this.maskType != undefined) {
      let mask = this.maskTypes.find((x) => x.id == this.maskType);
      this.inputMask = mask != undefined ? mask.mask : '';
    }
  },
  methods: {
    updateValue: function(value) {
      this.$emit('input', value);
    },
    emitValue(value) {
      this.validateTime(value);
      if (!this.isValidTime) {
        return this.$emit('input', '');
      }
      this.$emit('input', this.handlerFormatTime(value));
    },
    formatMaskedText(value) {
      //conditionals to remove masks from text
      if (this.maskType == 'Phone') {
        return value.replace(/-|[()]/gi, '');
      } else if (this.maskType == 'AppointmentNumber') {
        return value.replace(/-/gi, '');
      }

      return value;
    },
    handlerMeridian(value) {
      this.meridian = value;
      this.emitValue(this.value);
    },
    handlerFormatTime(value) {
      const time12 = `${value} ${this.meridian}`;
      var match = time12.match(/^(\d+):(\d+) (\w+)$/);
      var hours = parseInt(match[1]);
      var minutes = parseInt(match[2]);
      var period = match[3].toUpperCase();

      if (period === 'PM' && hours < 12) {
        hours += 12;
      } else if (period === 'AM' && hours === 12) {
        hours = 0;
      }

      var hoursString = hours.toString().padStart(2, '0');
      var minutesString = minutes.toString().padStart(2, '0');

      return hoursString + ':' + minutesString;
    },
    convertTime24to12(time24) {
      if (!this.isHourValid(time24)) {
        return '';
      }
      var timeParts = time24.split(':');
      var hours = parseInt(timeParts[0]);
      var minutes = timeParts[1];

      hours = hours % 12;
      hours = hours ? hours : 12;

      return hours.toString().padStart(2, '0') + ':' + minutes;
    },
    isHourValid(value) {
      const isValueADateObj = value > 0 && value instanceof Date;
      // JSF: if value already came in 12 format with AM/PM at the end (ex. '02:30 PM')
      // then we don't need to validate if is a 24 format because .isValid() will return true always.
      const isValueA12HourFormat =
        !isValueADateObj &&
        typeof value === 'string' &&
        ['AM', 'PM'].some((word) => value.toUpperCase().indexOf(word) > 0);
      const is24Valid =
        !isValueA12HourFormat && moment(value, FORMAT_HOUR_24).isValid();
      if (is24Valid) {
        this.is24Format = true;
        return true;
      } else {
        const is12Valid = moment(
          moment(value, FORMAT_HOUR_AM_PM).format(FORMAT_HOUR_AM_PM),
          FORMAT_HOUR_24
        ).isValid();

        if (is12Valid) {
          this.is24Format = false;
          return true;
        }
      }
      return false;
    },
    validateTime(time) {
      const time24 = this.handlerFormatTime(time);

      const parsedTime = moment(time24, FORMAT_HOUR_24, true);
      if (this.meridian == 'AM') {
        const startTime = moment('7:00', FORMAT_HOUR_24);
        const endTime = moment('11:59', FORMAT_HOUR_24);
        this.isValidTime = parsedTime.isBetween(startTime, endTime, null, '[]');
      } else if (this.meridian == 'PM') {
        const startTime = moment('12:00', FORMAT_HOUR_24);
        const endTime = moment('19:45', FORMAT_HOUR_24);
        this.isValidTime = parsedTime.isBetween(startTime, endTime, null, '[]');
      }

      var timeSplitted = time24.split(':');
      if (timeSplitted.length > 1) {
        this.isValidTime = this.isValidTime && Number(timeSplitted[1]) % 5 == 0;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.form-control {
  border: 1px solid #c5cdcf;
}

.form-control:focus {
  border-color: none;
  box-shadow: none;
}

.leftInput {
  padding-left: 40px;
}
.sucess-icon {
  font-size: 19px;
  position: absolute;
  top: 9px;
  right: 7px;
  color: #3f5b60;
  margin-right: 0.2rem;
}
.sucess-icon:before {
  content: '\f058';
  color: #2db782;
}
span.invalid:not(input) {
  color: #e85c5c;
}
.form-control-icon-normal {
  position: absolute;
  top: 9px;
  right: 10px;
  color: #3f5b60;
  margin-right: 0.2rem;
}
.form-control-icon-normal.left {
  left: 15px;
  top: 11px;
  width: 20px;
}

.form-control-icon-invalid {
  color: #e85c5c;
  position: absolute;
  top: 9px;
  right: 10px;
  font-size: 19px;
}
.input-label {
  height: 19px;
  text-align: left;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
  line-height: 19px;
}

.form-control:disabled {
  background: #fff;
  cursor: not-allowed;
}

.modal-label {
  font-weight: 300;
  font-family: normal;
}

.custom-error i {
  float: left;
  margin-top: 15px;
  margin-right: 10px;
  color: #e85c5c;
}

.was-Invalidated {
  border: 1px solid #ff0018 !important;
}

.orange-icon {
  color: #ff7058;
}

.form-control-meridian {
  position: absolute;
  top: 9px;
  right: 10px;
  color: #3f5b60;
  margin-right: 0.2rem;
}

.bl {
  border-left: 1px solid #dedede;
}

.pointer {
  cursor: pointer;
}

.dropdown-toggle {
  border-radius: 0 4px 4px 0;
  border: 1px solid #ced4da !important;
  border-left: 0 !important;
}

.input-border {
  border-radius: 4px 0 0 4px !important;
}
</style>
